import $ from 'jquery'

let $main

export function initialise() {
  $main = $('#tessitura-content')

  if (!$main.length) {
    return
  }

  injectSections()
}

function injectSections() {
  const $target = $('[data-tessitura-sections]')
  const script = $target.attr('data-tessitura-sections')
  const url = script + '?url=' + window.encodeURIComponent(window.location.href)
  $target.load(url)
}
